'use client';

import { useState, useEffect } from 'react';

import BreakpointIndicator from '@/components/BreakpointIndicator';
import { DevModeIndicatorWrapper } from '@/components/DevModeIndicatorWrapper';

/**
 * Wrapper component for development indicators.
 * Only renders on the client side to prevent hydration errors.
 */
export function IndicatorWrapper() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Don't render anything during SSR or outside development mode.
  if (!isMounted || process.env.NODE_ENV !== 'development') return null;

  return (
    <div
      className="pointer-events-none fixed inset-x-0 z-[60] flex justify-center"
      style={{ bottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}>
      <div className="pointer-events-auto flex items-center gap-2 rounded-full border border-white/10 bg-slate-900/85 px-3 py-2 shadow-xl backdrop-blur-sm">
        <BreakpointIndicator />
        <DevModeIndicatorWrapper />
      </div>
    </div>
  );
}
